import {Link, useNavigate} from 'react-router-dom'
import {DASHBOARD} from 'router/routes'
import {toAbsoluteUrl} from 'helpers'
import Button from 'components/shared/buttons'

const NoPageFound = () => {
  const navigate = useNavigate()
  const redirectToDashboard = () => navigate(DASHBOARD)

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
        <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-20'>
          <Link to={DASHBOARD} className='mb-10 pt-lg-20'>
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/logos/main-logo.svg')}
              className='h-50px mb-5'
            />
          </Link>

          <div className='pt-lg-10 mb-10'>
            <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Page Not Found</h1>

            <div className='fw-bold fs-3 text-gray-400 mb-15'>
              The page you looked not found! <br /> Plan your blog post by choosing a topic
            </div>

            <div className='text-center'>
              <Button label='Go to homepage' className='fw-bolder' onClick={redirectToDashboard} />
            </div>
          </div>

          <div
            className='
            d-flex
            flex-row-auto
            bgi-no-repeat
            bgi-position-x-center
            bgi-size-contain
            bgi-position-y-bottom
            min-h-100px min-h-lg-350px
          '
            style={{
              backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/sketchy-1/17.png')}')`,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default NoPageFound
